module.exports = __webpack_public_path__ + "static/media/barricade.c050f4a1.svg";